import { queryOptions, useQuery } from '@tanstack/react-query';
import { z } from 'zod';
import { fetcher } from '@/utils/fetcher';

export const configsSchema = z
  .object({
    API_ENDPOINT: z.string().length(0).or(z.string().url()),
    WEBSOCKET_ENDPOINT: z.string().startsWith('ws'),
    AppDownloadUrl: z.string().length(0).or(z.string().url()),
  })
  .strip();
type Configs = z.infer<typeof configsSchema>;

const configsQueryOptions = queryOptions({
  queryKey: ['/GetConfig'],
  queryFn: ({ signal }) =>
    fetcher<Configs>(
      '/GetConfig',
      { config: 'endpoint' },
      {
        method: 'get',
        schema: configsSchema,
        signal,
        requireAuth: false,
      },
    ),
  staleTime: 30 * 60 * 1000, // 30 mins
  gcTime: 60 * 60 * 1000, // 1 hour
  refetchOnWindowFocus: false,
  refetchOnReconnect: false,
});

export default function useConfigs() {
  return useQuery(configsQueryOptions);
}
